"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WeblabRuleOperator;
(function (WeblabRuleOperator) {
    WeblabRuleOperator["AND"] = "AND";
    WeblabRuleOperator["OR"] = "OR";
})(WeblabRuleOperator || (WeblabRuleOperator = {}));
exports.default = WeblabRuleOperator;
